import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { IDay, IMonth } from 'features/schedule';

export const formatWithLocale = (date: string | Date, formatString: string) => {
	if (date) {
		const day = new Date(date);
		return format(day, formatString, { locale: ru });
	}

	return '';
};

export const getShortDayOfWeek = (date: string) => {
	const shortWeekdays = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
	const day = new Date(date);
	return shortWeekdays[day.getDay()];
};

export const getIsFirstDayOfMonth = (days: IDay[], day: IDay, index: number) => {
  if (index < 1) return false;

  const prevDate = days[index-1].date;
  const dayDate = day.date;

  const prevDayMonth = new Date(prevDate).getMonth();
  const dayMonth = new Date(dayDate).getMonth();

  const isFirst = prevDayMonth < dayMonth;

  return isFirst;
}

export const mappingDaysToMonths = (days: IDay[]) => {
  const map = new Map();
  for (let index = 0; index < days.length; index++) {
    const day = days[index];

    const month = new Date(day.date).toLocaleDateString('ru-RU', {month: 'long'});
    if (!map.has(month)) {
      map.set(month, [day]);
    } else {
      map.set(month, [...map.get(month), day])
    }
  }

  const arr: IMonth[] = []
  for (const [key, value] of map.entries()) {
    arr.push({
      month: key,
      days: value,
    })
  }
  
  return arr;
}